var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentSelection,{tag:"Component",attrs:{"item":_vm.item,"is-busy":_vm.isBusy,"is-deleting":_vm.isDeleting},on:{"on:action-click":function($event){return _vm.onActionClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }